import React, { memo } from 'react';
import { Product } from '@portal/portal-core';
import ProductTab from 'components/product-tab';
import TabsContainer from 'components/tabs-container';
import SelectedTabContent from './selected-tab-content';

// NAMES_UI_TABS is typed as `any` in @portal/portal-core.
const { NAMES_UI_TABS } = Product;
const { flowJo, seqGeq, bdrc } = NAMES_UI_TABS;

const alwaysShowThesePages: string[] = [flowJo, seqGeq, bdrc];

interface ProductAccessEntry {
  name: string;
}

interface CostCenter {
  productAccess: ProductAccessEntry[];
}

interface UserAdminState {
  adminCostCenterList: Record<string, CostCenter>;
}

const licenseList = ({ adminCostCenterList }: UserAdminState): string[] =>
  Object.values(adminCostCenterList).reduce(
    (accum: string[], { productAccess }: CostCenter) =>
      productAccess.reduce(
        (products: string[], { name }: ProductAccessEntry) =>
          products.includes(name) === false ? [...products, name] : products,
        accum,
      ),
    alwaysShowThesePages,
  );

const renderProductTabs = (list: string[]): React.ReactNode =>
  (Object.values(NAMES_UI_TABS) as string[]).map((name) => (
    <ProductTab key={name} product={name} hidden={!list.includes(name)} />
  ));

interface TabContentAreaProps {
  userAdminState: UserAdminState;
}

const TabContentArea = memo(({ userAdminState }: TabContentAreaProps) => (
  <TabsContainer
    tabs={renderProductTabs(licenseList(userAdminState))}
    tabContent={<SelectedTabContent />}
  />
));

export default TabContentArea;
